import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

interface DecodedToken {
  username: string;
  sub: number;
  role: "admin" | "teacher" | "viewer";
  iat: number;
  exp: number;
}

function decodeJWT(token: string): DecodedToken | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    
    const decoded = JSON.parse(atob(parts[1]));
    return decoded as DecodedToken;
  } catch (e) {
    return null;
  }
}

export default function ProtectedRoute({ 
  children, 
  allow 
}: { 
  children: React.ReactNode; 
  allow: ("admin" | "teacher" | "viewer")[] 
}) {
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [role, setRole] = useState<"admin" | "teacher" | "viewer" | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    
    if (!token) {
      setLoading(false);
      setIsAuthorized(false);
      return;
    }

    const decoded = decodeJWT(token);
    if (!decoded) {
      localStorage.removeItem("jwtToken");
      setLoading(false);
      setIsAuthorized(false);
      return;
    }

    // 토큰 만료 확인
    const now = Math.floor(Date.now() / 1000);
    if (decoded.exp < now) {
      localStorage.removeItem("jwtToken");
      setLoading(false);
      setIsAuthorized(false);
      return;
    }

    setRole(decoded.role);
    setIsAuthorized(allow.includes(decoded.role));
    setLoading(false);
  }, [allow]);

  if (loading) return <div>로딩중...</div>;
  if (!isAuthorized) {
    if (role === "admin" || role === "teacher") return <Navigate to="/profile" replace />;
    if (role === "viewer") return <Navigate to="/viewer" replace />;
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}